// 引入模块
import axios from "axios"
import qs from 'qs'
import store from '../store/store'
import { API_BASE_URL, REQUEST_TIMEOUT, WITH_CREDENTIALS } from '../config'
// 是否允许跨域
axios.defaults.withCredentials=WITH_CREDENTIALS;
// axios初始化：延迟时间，主路由地址
let instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: REQUEST_TIMEOUT
});

// console.log(store.state.token)
// 设置拦截器
instance.interceptors.request.use((config,url) => {
  // console.log(store.state)
  console.log(config,url)
  try{
  	if (store.state.token) {
  	  config.headers['authorization'] = 'Bearer '+store.state.token;
  	}
  	config.headers['Content-Type'] = 'application/json'
  	return config
  }catch(e){
  	//TODO handle the exception
  }
})
//响应拦截器
instance.interceptors.response.use(function(response){
  // console.log(response)
  // if (response.data.state===401 || response.status===401) {
	 //  store.commit('setShowLogin',1)
	 //  return
  // }
  //对响应数据做些事
  console.log(response)
  return response;
},function(error){
  //请求错误时做些事
  console.log(error)
  console.log(error.response)
  if(error.response.status===401) {
	  store.commit('setShowLogin',1)
  }
  // return Promise.reject(error);
});
 
// 是否销毁拦截器
// 1.给拦截器起个名称 var myInterceptors = instance.interceptors.requesst.use();
// 2.instance.interceptors.request.eject(myInterceptor);
 
// 请求成功的回调
function checkStatus(res) {
   console.log(res)
   if(!res) return {state: 200,message:'',data:''}
  //请求结束成功
  try{
	if (res.status === 200 || res.status === 304) {
		return res.data
	}
  	return res
  }catch(e){
  	console.log(e)
  }
}
// 请求失败的回调
function checkCode(res) {
  if(!res) return {state: 200,message:'',data:''}
  try{
  	if (res.code === 0) {
  	  throw new Error(res.msg)
  	}
  	return res
  }catch(e){
  	//TODO handle the exception
  }
}
//模块化导出
export default {
  get(url, params,headers) {
    if (!url) return;
    return instance({
      method: 'get',
      url: url,
      params,
	  headers:headers,
      timeout: 30000
    }).then(checkStatus).then(checkCode)
  },
  post(url, data) {
    if (!url) return;
    return instance({
      method: 'post',
      url: url,
      data: data,
      timeout: 30000
    }).then(checkStatus).then(checkCode)
  },
  postFile(url, data) {
    if (!url) return;
    return instance({
      method: 'post',
      url: url,
      data
    }).then(checkStatus).then(checkCode)
  }
}



// WEBPACK FOOTER //
// ./src/utils/axios.js